import { enemyByKind } from "./enemy-defs.js";
import type { HeroAssets } from "./hero.js";
/**
 * Shared combat chrome: the little HP bar drawn above a combatant in a
 * Viewport overlay pass. One implementation, used by the arena (its combat
 * sandbox) and the game (hero + every live enemy on the floor) — the arena
 * used to own a private copy; the game's dungeon NPCs need the same bar, so
 * it lives here. Pure canvas: no state, no DOM beyond the given context.
 */

/** Draw a labelled HP bar centred above the combatant at screen feet
 *  (feet.x, feet.y). `headRise` is how many px above the feet the bar sits
 *  (the sprite body rises ~a tile; 84 clears a 96-px billboard at typical
 *  zoom). Green > yellow > red as the pool empties. */
export function drawHpBar(
  ctx: CanvasRenderingContext2D,
  feet: { x: number; y: number },
  label: string,
  hp: number,
  maxHp: number,
  headRise: number,
): void {
  const w = 56;
  const bx = feet.x - w / 2;
  const by = feet.y - headRise;
  const ratio = maxHp > 0 ? hp / maxHp : 0;
  ctx.fillStyle = "rgba(0,0,0,0.6)";
  ctx.fillRect(bx - 1, by - 1, w + 2, 8);
  ctx.fillStyle = "#3a1215";
  ctx.fillRect(bx, by, w, 6);
  ctx.fillStyle = ratio > 0.5 ? "#6fdc6f" : ratio > 0.25 ? "#e0b84a" : "#e0584a";
  ctx.fillRect(bx, by, Math.max(0, Math.round(w * ratio)), 6);
  ctx.strokeStyle = "rgba(0,0,0,0.8)";
  ctx.lineWidth = 1;
  ctx.strokeRect(bx - 1, by - 1, w + 2, 8);
  ctx.fillStyle = "#e6dfc9";
  ctx.font = "11px ui-monospace, Menlo, monospace";
  ctx.textAlign = "center";
  ctx.fillText(`${label}  ${hp}/${maxHp}`, feet.x, by - 4);
  ctx.textAlign = "left";
}

/** Keep labels above oversized boss billboards at the rendered zoom. */
export function enemyHeadRise(assets: HeroAssets | null, kind: string, zoom: number): number {
  const height = assets?.atlas.npcs?.[enemyByKind(kind)?.family ?? kind]?.dims[1] ?? 96;
  return Math.max(84, height - 16) * zoom;
}
